const FontSizes = {
  xs: "0.7rem",
  sm: "0.8rem",
  md: "0.875rem",
  lg: ".925rem",
  xl: "1rem",
  "2xl": "1.25rem",
  "3xl": "1.5rem",
  "4xl": "1.875rem",
  "5xl": "2.25rem",
  "6xl": "3rem",
  "7xl": "3.75rem",
  "8xl": "4.5rem",
  "9xl": "6rem",
}

export default FontSizes
